import { TooltipProps, useDisclosure } from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";
import TooltipIconButton, {
  TooltipIconButtonProps,
} from "components/Shared/TooltipIconButton";
import ConfirmModalMutation, {
  ConfirmModalMutationProps,
} from "./ConfirmModalMutation";

type Props<TData = unknown, TVariables = unknown> = Omit<
  ConfirmModalMutationProps<TData, TVariables>,
  "isOpen" | "onClose"
> & {
  buttonProps?: Partial<Omit<TooltipIconButtonProps, "onClick">>;
  tooltipProps?: Partial<TooltipProps>;
};

export default function DeleteConfirmModalButton<TData, TVariables>({
  buttonProps,
  tooltipProps,
  ...rest
}: Props<TData, TVariables>) {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <TooltipIconButton
        label={rest.label}
        size="sm"
        colorScheme="red"
        variant="ghost"
        borderRadius="lg"
        textTransform="none"
        icon={<DeleteIcon />}
        {...buttonProps}
        tooltipProps={tooltipProps}
        onClick={onOpen}
      />

      <ConfirmModalMutation
        {...{ isOpen, onClose }}
        confirmButtonLabel="Delete"
        confirmText="Are you sure? You won’t be able to undo this action afterwards."
        {...rest}
      />
    </>
  );
}
